import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Seo from "../components/Seo";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Hero } from "../components/sections/Hero";
import { PaymentPartners } from "../components/sections/PaymentPartners";
import { Problem } from "../components/sections/Problem";
import { Philosophy } from "../components/sections/Philosophy";
import { HowItWorks } from "../components/sections/HowItWorks";
import { PaymentPolicies } from "../components/sections/PaymentPolicies";
import { ProductScreens } from "../components/sections/ProductScreens";
import { Features } from "../components/sections/Features";
import { Pricing } from "../components/sections/Pricing";
import { Audience } from "../components/sections/Audience";
import { Security } from "../components/sections/Security";
import { Faq } from "../components/sections/Faq";
import { FinalCta } from "../components/sections/FinalCta";
import { scrollToId } from "../components/AppButtons";

export default function Landing() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      setTimeout(() => scrollToId(id), 300);
    }
  }, [hash]);

  return (
    <div className="bg-white" data-testid="landing-page">
      <Seo titleKey="meta.home.title" descKey="meta.home.description" path="" pageType="home" />
      <Header />
      <main>
        <Hero />
        <PaymentPartners />
        <Problem />
        <Philosophy />
        <HowItWorks />
        <PaymentPolicies />
        <ProductScreens />
        <Features />
        <Pricing />
        <Audience />
        <Security />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
